import { NotificationActionType, NotificationsActionTypes } from '../enums/notifications.enum';
import { TranslateService } from '@ngx-translate/core';

// Method to determine button texts based on notification type
export function getButtonActions(notificationType: string): NotificationActionType[] {
  switch (notificationType) {
    case NotificationsActionTypes.GroupNotifications:
    case NotificationsActionTypes.UpdateGroupNotifications:
    case NotificationsActionTypes.UnapprovedUserGroups:
    case NotificationsActionTypes.GroupForApprovals:
    case NotificationsActionTypes.NewsNotifications:
    case NotificationsActionTypes.UpdateNewsNotifications:
    case NotificationsActionTypes.EventsNotifications:
    case NotificationsActionTypes.EventUpdateNotifications:
    case NotificationsActionTypes.CoursesNotifications:
    case NotificationsActionTypes.UpdateCourseNotifications:
    case NotificationsActionTypes.UserWantsToJoinCourseNotificationToCreator:
    case NotificationsActionTypes.InvitedCoursesNotifications:
    case NotificationsActionTypes.TaskNotifications:
    case NotificationsActionTypes.UpdateTasksNotifications:
    case NotificationsActionTypes.MessageNotifications:
    case NotificationsActionTypes.SurveyNotifications:
    case NotificationsActionTypes.UpdateSurveyNotification:
    case NotificationsActionTypes.RoomNotifications:
    case NotificationsActionTypes.RoomUpdateNotifications:
    case NotificationsActionTypes.InstructorNotifications:
    case NotificationsActionTypes.UpdateInstructorNotifications:
    case NotificationsActionTypes.FaqsNotifications:
    case NotificationsActionTypes.UpdateFaqsNotificationToadmin:
    case NotificationsActionTypes.FaqsCategoryNotifications:
      return [NotificationActionType.Deny, NotificationActionType.Accept];
    case NotificationsActionTypes.DenyGroupNotifications:
    case NotificationsActionTypes.AcceptGroupUserNotifications:
    case NotificationsActionTypes.GroupNotificationExistingUsers:
    case NotificationsActionTypes.UpdatedGroupNotificationForExistingUsers:
    case NotificationsActionTypes.GetPublishedGroupNotificationToCreator:
    case NotificationsActionTypes.DenyNewsNotifications:
    case NotificationsActionTypes.ApprovedPublishNewsNotificationToCreator:
    case NotificationsActionTypes.ApprovedUpdateNewsNotificationToCreator:
    case NotificationsActionTypes.DenyEventNotificationsToCreator:
    case NotificationsActionTypes.ApprovedEventNotificationsToCreator:
    case NotificationsActionTypes.ApprovedUpdateEventNotificationsToCreator:
    case NotificationsActionTypes.UpdatedEventNotificationForExistingUsers:
    case NotificationsActionTypes.UserJoinedByCreatorNotification:
    case NotificationsActionTypes.UpdatedCourseNotificationForExistingUsers:
    case NotificationsActionTypes.InternalCourseInstructorNotifications:
    case NotificationsActionTypes.InternalUpdateCourseInstructorNotifications:
    case NotificationsActionTypes.ApprovedCourseNotificationsToCreator:
    case NotificationsActionTypes.ApprovedUpdateCourseNotificationsToCreator:
    case NotificationsActionTypes.DenyCourseNotificationsToCreator:
    case NotificationsActionTypes.GetDenyPublishTaskByAdminNotificationstoCreator:
    case NotificationsActionTypes.GetAcceptPublishTaskByAdminNotificationstoCreator:
    case NotificationsActionTypes.AcceptUpdatedTaskByAdminNotificationstoCreator:
    case NotificationsActionTypes.UpdatedTaskNotificationForExistingUsers:
    case NotificationsActionTypes.CompletedTaskNotificationToOrganizer:
    case NotificationsActionTypes.GetAcceptPublishSurveyByAdminNotificationstoCreator:
    case NotificationsActionTypes.PublishUpdateSurveyByAdminNotificationstoCreator:
    case NotificationsActionTypes.GetDenyPublishSurveyByAdminNotificationstoCreator:
    case NotificationsActionTypes.ApprovedRoomNotificationsToCreator:
    case NotificationsActionTypes.ApprovedUpdateRoomNotificationsToCreator:
    case NotificationsActionTypes.DenyRoomNotificationsToCreator:
    case NotificationsActionTypes.DenyInstructNotificationsToCreator:
    case NotificationsActionTypes.ApprovedInstructNotificationsToCreator:
    case NotificationsActionTypes.ApprovedUpdateInstructNotificationsToCreator:
    case NotificationsActionTypes.ApprovedFaqNotification:
    case NotificationsActionTypes.UpdateFaqsNotificationToAuthor:
    case NotificationsActionTypes.FaqsDenyNotificationToAuthor:
    case NotificationsActionTypes.InvitedSurveyNotifications:
    case NotificationsActionTypes.UnapprovedTasks:
    case NotificationsActionTypes.UnapprovedSubTask:
    case NotificationsActionTypes.InvitedEventsNotifications: // this invited event was added here for user to have multiple option to accept events
      return [NotificationActionType.View];
    default:
      return [];
  }
}

export function getText(notificationSection: NotificationsActionTypes, translateService: TranslateService): string {
  let text: string;

  switch (notificationSection) {
    case NotificationsActionTypes.GroupNotifications:
      text = 'wants to join a Group';
      break;
    case NotificationsActionTypes.UpdateGroupNotifications:
      text = 'wants to publish an updated Group';
      break;
    case NotificationsActionTypes.UpdatedGroupNotificationForExistingUsers:
      text = 'has updated the Group';
      break;
    case NotificationsActionTypes.UnapprovedUserGroups:
      text = 'invited you to';
      break;
    case NotificationsActionTypes.GroupForApprovals:
      text = 'wants to publish a Group';
      break;
    case NotificationsActionTypes.DenyGroupNotifications:
      text = 'has denied the Group';
      break;
    case NotificationsActionTypes.AcceptGroupUserNotifications:
      text = 'has been added to the Group';
      break;
    case NotificationsActionTypes.GetPublishedGroupNotificationToCreator:
      text = 'has published the Group';
      break;
    case NotificationsActionTypes.NewsNotifications:
      text = 'wants to publish a News';
      break;
    case NotificationsActionTypes.UpdateNewsNotifications:
      text = 'wants to publish an updated News';
      break;
    case NotificationsActionTypes.DenyNewsNotifications:
      text = 'has denied the News';
      break;
    case NotificationsActionTypes.ApprovedPublishNewsNotificationToCreator:
      text = 'has published the News';
      break;
    case NotificationsActionTypes.ApprovedUpdateNewsNotificationToCreator:
      text = 'has updated the News';
      break;
    case NotificationsActionTypes.EventsNotifications:
      text = 'wants to publish an Event';
      break;
    case NotificationsActionTypes.EventUpdateNotifications:
      text = 'wants to publish an updated Event';
      break;
    case NotificationsActionTypes.DenyEventNotificationsToCreator:
      text = 'has denied the Event';
      break;
    case NotificationsActionTypes.ApprovedEventNotificationsToCreator:
      text = 'has published the Event';
      break;
    case NotificationsActionTypes.ApprovedUpdateEventNotificationsToCreator:
      text = 'has updated the Event';
      break;
    case NotificationsActionTypes.InvitedEventsNotifications:
      text = 'invited you to an Event';
      break;
    case NotificationsActionTypes.UpdatedEventNotificationForExistingUsers:
      text = 'has updated Event for existing users';
      break;
    case NotificationsActionTypes.CoursesNotifications:
      text = 'wants to publish a Course';
      break;
    case NotificationsActionTypes.UpdateCourseNotifications:
      text = 'wants to publish an updated Course';
      break;
    case NotificationsActionTypes.UserWantsToJoinCourseNotificationToCreator:
      text = 'wants to join a Course you have created';
      break;
    case NotificationsActionTypes.UserJoinedByCreatorNotification:
      text = 'has been added to a Course by the creator';
      break;
    case NotificationsActionTypes.InvitedCoursesNotifications:
      text = 'invited you to a Course';
      break;
    case NotificationsActionTypes.UpdatedCourseNotificationForExistingUsers:
      text = 'has updated Course for existing users';
      break;
    case NotificationsActionTypes.InternalCourseInstructorNotifications:
      text = 'wants to assign Instructor to a Course';
      break;
    case NotificationsActionTypes.InternalUpdateCourseInstructorNotifications:
      text = 'wants to update assigned Instructor of a Course';
      break;
    case NotificationsActionTypes.ApprovedCourseNotificationsToCreator:
      text = 'has published the Course';
      break;
    case NotificationsActionTypes.ApprovedUpdateCourseNotificationsToCreator:
      text = 'has updated the Course';
      break;
    case NotificationsActionTypes.DenyCourseNotificationsToCreator:
      text = 'has denied the Course';
      break;
    case NotificationsActionTypes.TaskNotifications:
      text = 'wants to publish a Task';
      break;
    case NotificationsActionTypes.UpdateTasksNotifications:
      text = 'wants to publish an updated Task';
      break;
    case NotificationsActionTypes.UnapprovedTasks:
      text = 'invited you to a Task';
      break;
    case NotificationsActionTypes.UnapprovedSubTask:
      text = 'invited you to a Task';
      break;
    case NotificationsActionTypes.GetDenyPublishTaskByAdminNotificationstoCreator:
      text = 'has denied the Task';
      break;
    case NotificationsActionTypes.GetAcceptPublishTaskByAdminNotificationstoCreator:
      text = 'has published the Task';
      break;
    case NotificationsActionTypes.AcceptUpdatedTaskByAdminNotificationstoCreator:
      text = 'has updated the Task';
      break;
    case NotificationsActionTypes.UpdatedTaskNotificationForExistingUsers:
      text = 'has updated the Task';
      break;
    case NotificationsActionTypes.CompletedTaskNotificationToOrganizer:
      text = 'has completed the Task';
      break;
    case NotificationsActionTypes.MessageNotifications:
      text = 'has sent you a message';
      break;
    case NotificationsActionTypes.SurveyNotifications:
      text = 'wants to publish a Survey';
      break;
    case NotificationsActionTypes.UpdateSurveyNotification:
      text = 'wants to publish an updated Survey';
      break;
    case NotificationsActionTypes.InvitedSurveyNotifications:
      text = 'has invited you to participate in a Survey';
      break;
    case NotificationsActionTypes.GetAcceptPublishSurveyByAdminNotificationstoCreator:
      text = 'has published the Survey';
      break;
    case NotificationsActionTypes.PublishUpdateSurveyByAdminNotificationstoCreator:
      text = 'has updated the Survey';
      break;
    case NotificationsActionTypes.GetDenyPublishSurveyByAdminNotificationstoCreator:
      text = 'has denied the Survey';
      break;
    case NotificationsActionTypes.RoomNotifications:
      text = 'wants to publish a Room';
      break;
    case NotificationsActionTypes.RoomUpdateNotifications:
      text = 'wants to publish an updated Room';
      break;
    case NotificationsActionTypes.ApprovedRoomNotificationsToCreator:
      text = 'has published the Room';
      break;
    case NotificationsActionTypes.ApprovedUpdateRoomNotificationsToCreator:
      text = 'has updated the Room';
      break;
    case NotificationsActionTypes.DenyRoomNotificationsToCreator:
      text = 'has denied the Room';
      break;
    case NotificationsActionTypes.InstructorNotifications:
      text = 'wants to publish an Instructor';
      break;
    case NotificationsActionTypes.UpdateInstructorNotifications:
      text = 'wants to publish an updated Instructor';
      break;
    case NotificationsActionTypes.DenyInstructNotificationsToCreator:
      text = 'has denied the Instructor';
      break;
    case NotificationsActionTypes.ApprovedInstructNotificationsToCreator:
      text = 'has published the Instructor';
      break;
    case NotificationsActionTypes.ApprovedUpdateInstructNotificationsToCreator:
      text = 'has updated the Instructor';
      break;
    case NotificationsActionTypes.FaqsNotifications:
      text = 'wants to publish an FAQ';
      break;
    case NotificationsActionTypes.UpdateFaqsNotificationToadmin:
      text = 'wants to publish an updated FAQ';
      break;
    case NotificationsActionTypes.ApprovedFaqNotification:
      text = 'has published the FAQ';
      break;
    case NotificationsActionTypes.UpdateFaqsNotificationToAuthor:
      text = 'wants to publish an updated FAQ';
      break;
    case NotificationsActionTypes.FaqsDenyNotificationToAuthor:
      text = 'has denied the FAQ';
      break;
    case NotificationsActionTypes.FaqsCategoryNotifications:
      text = 'wants to publish an FAQ category';
      break;
    default:
      text = 'Unknown notification type';
  }

  return translateService.instant(text);
}
